<template>
  <el-form :model="queryForm" ref="queryForm" :rules="rules" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="企业名称" prop="cliEntName">
          <el-input v-model="queryForm.cliEntName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="企业用户身份(DXPID)" prop="cliEntDxpid">
          <el-input v-model="queryForm.cliEntDxpid"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<style scoped>
.btn-sw {
  margin-top: 23px;
}
</style>
<script>
import smApi from "@/module/cnetong/client/sm/SmApi.js";
let defaultData = {
  cliEntDxpid: "",
  cliEntName: "",
  entHsmIdx:"",
  uuid: ""
};
export default {
  components: { smApi },
  props: {
    edi: Object
  },
  data() {
    return {
      rules: {
        cliEntName: [
          { required: true, message: "此项为必填项", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 200 个字符", trigger: "blur" }
        ],
        cliEntDxpid: [
          { required: true, message: "此项为必填项", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        entHsmIdx: [
          { required: true, message: "此项为必填项", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
      },
      queryForm: Object.assign({}, defaultData)
    };
  },
  methods: {
    save() {
      this.$refs.queryForm.validate(valid => {
        if (valid) {
          if (this.edi.uuid) {
            this.queryForm.uuid = this.edi.uuid;
            smApi.edit(this.queryForm).then(() => {
              this.$emit("son");
            });
          } else {
            smApi.save(this.queryForm).then(() => {
              this.$emit("son");
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    close() {
      this.edi.show = false;
    },
    selectInfo(param) {
      smApi.select(param).then(respData => {
        this.queryForm.cliEntName = respData.datarows[0].clientname;
        this.queryForm.cliEntDxpid = respData.datarows[0].clientdxpid;
      });
    }
  },
  watch: {},
  mounted() {
    if (this.edi.uuid) {
      this.selectInfo({ uuid: this.edi.uuid });
    }
  }
};
</script>
